import ErrorPage from 'next/error';
import Head from 'next/head';
import React, { useEffect } from 'react';
import { Grid, Row } from 'react-styled-flexboxgrid';
import styled, { ThemeProvider } from 'styled-components';
import HeroPost from '../../components/blog/HeroPost';
import PostPreview from '../../components/blog/PostPreview';
import { HeadingOne } from '../../components/Text';
import { getAllPostsForHome } from '../../lib/contentful';
import { WHITE_LABEL_BRAND, WHITE_LABEL_TWITTER } from '../../lib/white-label';
import { NextSeo } from 'next-seo';
import { analytics } from '../../lib/analytics';

const Container = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
`;

function Blog({ allPosts, preview }) {
  useEffect(() => {
    analytics.page('Blogs');
  }, []);

  if (process.env.WHITE_LABEL_ORG) {
    return <ErrorPage statusCode={404} />;
  }
  const heroPost = allPosts[0];
  const morePosts = allPosts.slice(1);

  return (
    <>
      <NextSeo
        title={`${WHITE_LABEL_BRAND} Blog`}
        description={`${WHITE_LABEL_BRAND} blog curated with reseller focused blog posts.`}
      />
      <Head>
        <meta name="twitter:site" content={WHITE_LABEL_TWITTER} />
        <meta name="twitter:title" content={`${WHITE_LABEL_BRAND} Blog`} />
        <meta
          name="twitter:description"
          content={`${WHITE_LABEL_BRAND} blog curated with reseller focused blog posts.`}
        />
      </Head>
      <Container>
        <HeadingOne>Blog</HeadingOne>
        {/* <Subheading>To help you with your purchase decisions</Subheading> */}
        <ThemeProvider
          theme={{
            flexboxgrid: {
              outerMargin: 0,
              gutterWidth: 1,
            },
          }}
        >
          <Grid
            fluid
            style={{
              marginRight: 0,
              marginLeft: 0,
              marginBottom: '2rem',
              width: '100%',
            }}
          >
            {heroPost && (
              <Row>
                <HeroPost
                  title={heroPost.title}
                  coverImage={heroPost.coverImage}
                  date={heroPost.date}
                  author={heroPost.author}
                  slug={heroPost.slug}
                  excerpt={heroPost.excerpt}
                />
              </Row>
            )}
            {morePosts.length > 0 && (
              <Row className="mt-10">
                <HeadingOne>More posts</HeadingOne>
                <div className="w-full mt-4 grid grid-cols-1 md:grid-cols-2 md:gap-x-16 lg:grid-cols-3 lg:gap-x-50 gap-y-16 md:gap-y-24 mb-32">
                  {morePosts.map((post) => {
                    return (
                      <PostPreview
                        key={post.slug}
                        title={post.title}
                        coverImage={post.coverImage}
                        date={post.date}
                        author={post.author}
                        slug={post.slug}
                        excerpt={post.excerpt}
                      />
                    );
                  })}
                </div>
              </Row>
            )}
          </Grid>
        </ThemeProvider>
      </Container>
    </>
  );
}

export async function getStaticProps({ preview = false }) {
  const allPosts = (await getAllPostsForHome(preview)) ?? [];
  return {
    props: { preview, allPosts },
  };
}

export default Blog;
